export const ANDROID_APP_LINK = 'https://play.google.com/store/apps/details?id=com.bartering.forsa&pcampaignid=web_share';
export const IOS_APP_LINK = 'https://apps.apple.com/de/app/forsa-barter/id1554230580?l=en-GB';